/* eslint-disable react-hooks/exhaustive-deps */

import React, { useRef, useEffect, useState } from 'react';
import { currencyFormat, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { Image, Dropdown, Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import useMediaQuery from '@mui/material/useMediaQuery';

export const TopProductSupply = (props) => {
    const { title, details } = props;
    const bestSellingProducts = useRef(null);
    const classes = customStyles();
    const [datas, setDatas] = useState([]);
    const [type, setType] = useState('top_supply_product_15');
    const mobileDevice = useMediaQuery('(min-width:1300px)');
    let cI = 0;
    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(bestSellingProducts.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [
            ['Product Name', 'Product Name', 'Quantity', 'Unit', 'Amount']
        ];

        Object.keys(datas).length > 0 && Object?.entries(datas)?.map(([key, value]) => {
            return value && value.length > 0 && value.map((d, i) => {
                return newHead[i + 1] = [key, d.product, d.totalQuantity, d.unit, d.totalAmount];
            });
        })

        exportChatFile(title, newHead);
    }

    const handleChange = (value) => {
        setType(value);
        setDatas(details[value]);
    }

    useEffect(() => {
        if (details['top_supply_product_15']) {
            setDatas(details['top_supply_product_15']);
        }
    }, [details]);

    // const handleSortChange = (value) => {
    //     setSort(value);
    //     if (details && details[type] && details[type]?.length > 0) {
    //         details[type]?.sort((a, b) => b[value] - a[value]);
    //         setDatas(details[type]);
    //     }
    // }

    return (
        <div ref={bestSellingProducts} className={clsx(classes.totalChartDiv, classes.topProductSupply, { [classes.mobileDevice]: !mobileDevice })}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                <span className={classes.lastDaysRadioSupply}>                    
                    <RadioGroup
                        row
                        defaultValue={'top_supply_product_15'}
                        value={type}
                        onChange={(e) => handleChange(e.target.value)}>
                        <FormControlLabel value="top_supply_product_15" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="15 days" />
                        <FormControlLabel value="top_supply_product_30" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="30 days" />
                        <FormControlLabel value="top_supply_product_more_30" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="> 30 days" />
                    </RadioGroup>
                    {/* <RadioGroup
                        row
                        defaultValue={'quantity'}
                        value={sort}
                        onChange={(e) => handleSortChange(e.target.value)}>
                        <FormControlLabel value="quantity" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Quantity" />
                        <FormControlLabel value="amount" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="By Value" />
                    </RadioGroup> */}
                </span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={clsx(classes.topProductSupplyContent, classes.topProductSupplyContentSupply)}>
                {
                    datas && Object.keys(datas).length > 0 ? Object?.entries(datas)?.map(([key, value]) => (
                        <Row key={key} gutter={10}>
                            <Col span="24">
                                <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{key || '---'}</div>
                                {
                                    value && value.length > 0 ? value.map((d, i) => {
                                        if (cI >= 3) {
                                            cI = 0;
                                        }
                                        cI += 1;
                                        return (
                                            <Row key={i} gutter={10}>
                                                <Col span="24">
                                                    <div className={clsx(classes.textFieldColor, classes.margin10t, classes.fonSize13, classes.bold)}>{d?.product || '---'}</div>

                                                    <div className={clsx({ [classes.product_bg_green]: cI === 1 }, { [classes.product_bg_blue]: cI === 2 }, { [classes.product_bg_yellow]: cI === 3 }, classes.padding5)}>
                                                        <Row gutter={10}>
                                                            <Col span="4">
                                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Quantity</div>
                                                                <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{d?.totalQuantity || '---'}</div>
                                                            </Col>
                                                            <Col span="6">
                                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink')}>Unit</div>
                                                                <div className={clsx(classes.textFieldColor, classes.fonSize13)}>{d?.unit || '---'}</div>
                                                            </Col>
                                                            <Col span="14">
                                                                <div className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.textAlignRight)}>Amount</div>
                                                                <div className={clsx(classes.textFieldColor, classes.fonSize13, classes.textAlignRight)}>{d?.totalAmount ? '₹ ' + currencyFormat(d?.totalAmount) : '---'}</div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )
                                    }) : <Row key={"No products found"} gutter={10}>
                                        <Col span="24" className={clsx(classes.noResultsText, classes.textAlignCenter)}>Data Will be Displayed when transactions are recorded by the system</Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    )) : <Row key={"No products found"} gutter={10}>
                        <Col span="24" className={clsx(classes.noResultsText, classes.textAlignCenter)}>Data Will be Displayed when transactions are recorded by the system</Col>
                    </Row>
                }
            </div>
        </div>
    )
}